import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import React from "react";

const SettingsSidebar = () => {
  const routes = all_routes;
  const location = useLocation();
  const isLinkActive = (route: string) => {
    return location.pathname === route;
  };

  return (
    <div className="col-lg-3 theiaStickySidebar">
      <div className="stickybar">
        <div className="settings-widget">
          <div className="settings-menu">
            <ul>
              <li>
                <Link
                  to={routes.userSettings}
                  className={isLinkActive(routes.userSettings) ? "active" : ""}
                >
                  <i className="feather icon-user" /> Profile
                </Link>
              </li>

              <li>
                <Link
                  to={routes.userSecurity}
                  className={isLinkActive(routes.userSecurity) ? "active" : ""}
                >
                  <i className="feather icon-shield" /> Security
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSidebar;
